import RestClient from '../RestClient/RestClient';
import * as promobannerConstants from './PromotionalBannerApiConstants';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getHostConfig } from '../Common/RestConfig';

export const getPromotionalBannerDataForAllPages = (ntypeId, params) => { //eslint-disable-line
    /* istanbul ignore next */
    const promoUrl = ntypeId
        ? `${promobannerConstants.promotionabannerUrl}/${ntypeId}`
        : promobannerConstants.promotionabannerUrl;
    let config = {
        url: promoUrl,
        credentials: 'include',
        params,
        version: '/v1',
        apiHost: apiHosts.browse,
    };

    config = getHostConfig(config);
    return RestClient.get(config).then((json) => json);
};
